import { jsx as _jsx } from "react/jsx-runtime";
import ViewScansScreen from '~/modules/scans/screens/ViewScansScreen';
const routes = [
    {
        path: '/scans/:pid',
        element: _jsx(ViewScansScreen, {}),
    },
];
export default routes;
